import MetaForm from "./MetaForm";

class MetaFormUpdater {
    private metaformMap: Map<string, MetaForm | null> = new Map();
    constructor(name: string, metaform: MetaForm | null) {
        this.metaformMap.set(name, metaform);
    }

    updateField(section: string, field: string, value: any) {
        const defaultForm = this.metaformMap.get("default");
        if (defaultForm) {
            defaultForm.updateField(section, field, value);
        }
    }

    updateFormField(formName: string, section: string, field: string, value: any) {
        const defaultForm = this.metaformMap.get(formName);
        if (defaultForm) {
            defaultForm.updateField(section, field, value);
        }
    }

    add(name: string, metaform: MetaForm) {
        this.metaformMap.set(name, metaform);
    }

    destroy(name: string) {
        if (this.metaformMap && this.metaformMap.get(name)) {
            this.metaformMap.delete(name);
        }
    }
}

export default MetaFormUpdater;
